import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import hi from './locales/hi.json';
import gu from './locales/gu.json';
import mr from './locales/mr.json';
import bn from './locales/bn.json';
import te from './locales/te.json';
import ml from './locales/ml.json';
import od from './locales/od.json';
import kn from './locales/kn.json';
import pa from './locales/pa.json';
import ta from './locales/ta.json';

/**
 * Ported verbatim from the legacy app's public/i18n.js. Same storage key
 * (dawa_lang) so a pharmacy's chosen language carries over conceptually.
 *
 * These 123 keys cover login, nav, and the core CRUD screens that existed in
 * the legacy app. Newer areas (superadmin, substitutes, exports, GST/dead-
 * stock reports) have no legacy translation and still render in English —
 * add keys here as those screens get wired.
 */
export const LANGUAGES = {
  en: { name: 'English', native: 'English', flag: '🇬🇧' },
  hi: { name: 'Hindi', native: 'हिन्दी', flag: '🇮🇳' },
  gu: { name: 'Gujarati', native: 'ગુજરાતી', flag: '🇮🇳' },
  mr: { name: 'Marathi', native: 'मराठी', flag: '🇮🇳' },
  bn: { name: 'Bengali', native: 'বাংলা', flag: '🇮🇳' },
  te: { name: 'Telugu', native: 'తెలుగు', flag: '🇮🇳' },
  ml: { name: 'Malayalam', native: 'മലയാളം', flag: '🇮🇳' },
  od: { name: 'Odia', native: 'ଓଡ଼ିଆ', flag: '🇮🇳' },
  kn: { name: 'Kannada', native: 'ಕನ್ನಡ', flag: '🇮🇳' },
  pa: { name: 'Punjabi', native: 'ਪੰਜਾਬੀ', flag: '🇮🇳' },
  ta: { name: 'Tamil', native: 'தமிழ்', flag: '🇮🇳' },
} as const;

export type LanguageCode = keyof typeof LANGUAGES;

const STORAGE_KEY = 'dawa_lang';

function getSavedLanguage(): LanguageCode {
  const saved = localStorage.getItem(STORAGE_KEY);
  return saved && saved in LANGUAGES ? (saved as LanguageCode) : 'en';
}

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    hi: { translation: hi },
    gu: { translation: gu },
    mr: { translation: mr },
    bn: { translation: bn },
    te: { translation: te },
    ml: { translation: ml },
    od: { translation: od },
    kn: { translation: kn },
    pa: { translation: pa },
    ta: { translation: ta },
  },
  lng: getSavedLanguage(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export function setLanguage(code: LanguageCode) {
  localStorage.setItem(STORAGE_KEY, code);
  void i18n.changeLanguage(code);
}

export default i18n;
